import src from "IMAGE";
export default { src, width: 307, height: 337, blurWidth: 7, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAAQklEQVR42p2MSQoAIAwD/f9vRUXFJQbrfjQwFDohCjMZqIFYoGheopYsfETiiBFumUbBC1tWKfT5JGw5Cwe3fPIvG7dH3olUNJudAAAAAElFTkSuQmCC"};
